(($, Drupal) => {
  Drupal.behaviors.headerSelect = {
    attach: function attach(context) {
      $('.header__burger').once('add').each(function (index) {
        const el = this;
        const activeClass = 'open';
        const headerClass = 'header';
        const menuClass = 'header__menu';
        const stopScrollClass = 'overflow';

        el.addEventListener('click', function () {
          const burgerTrigger = this;
          const headerBlock = burgerTrigger.closest(`.${headerClass}`);
          const menuWrapper = headerBlock.querySelector(`.${menuClass}`);
          const htmlDocumentEl = document.querySelector('html');

          burgerTrigger.classList.toggle(activeClass);
          menuWrapper.classList.toggle(activeClass);
          htmlDocumentEl.classList.toggle(stopScrollClass);
        });
      });

      $('.search--opener').once('add').on('click', function () {
        const el = $(this);
        const searchContainer = el.closest('.header__search');
        const searchWrapper = searchContainer.find('.header__search-wrapper');
        const openClass = 'open';

        el.toggleClass(openClass);
        searchWrapper.toggleClass(openClass);
      });
    },
  };
})(jQuery, Drupal);
